import React, { useEffect, useState, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import ProductCard from "@/components/product-card";
import Grid from "@mui/material/Grid";
import EmptyStateMessage from "@/components/empty-state-message";
import amountToFixed from "@/helper/amountToFixed";
import { useMainPageContext } from "@/contexts/MainPageContext";

const emptyMessage = "No existe ningún artículo con los filtros seleccionados";
const INITIAL_ELEMENTS_COUNT = 45;
const PER_LOAD_COUNT = 20;
const CatalogGrid = ({ comboColor, productColor }) => {
    const {
        comboSelectedHandler,
        filteredCatalogsProducts: filteredCatalog,
        addProductToCart: productSelectedHandler,
    } = useMainPageContext();

    const [visibleItems, setVisibleItems] = useState([]);
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const loader = useRef(null);
    useEffect(() => {
        if (filteredCatalog.length > 0) {
            const initialItems = filteredCatalog.slice(0, INITIAL_ELEMENTS_COUNT);
            setVisibleItems(initialItems);
            setPage(1);
        } else {
            setVisibleItems([]);
            setPage(0);
        }
    }, [filteredCatalog]);

    useEffect(() => {
        if (!filteredCatalog.length) return;

        const observer = new IntersectionObserver(
            (entries) => {
                const target = entries[0];
                if (target.isIntersecting && !loading) {
                    setLoading(true);
                    const start = INITIAL_ELEMENTS_COUNT + (page - 1) * PER_LOAD_COUNT;
                    const end = start + PER_LOAD_COUNT;
                    const moreItems = filteredCatalog.slice(start, end);

                    if (moreItems.length > 0) {
                        setVisibleItems((prev) => [...prev, ...moreItems]);
                        setPage((prev) => prev + 1);
                    }

                    setLoading(false);
                }
            },
            { threshold: 1 },
        );

        if (loader.current) {
            observer.observe(loader.current);
        }

        return () => {
            if (loader.current) observer.unobserve(loader.current);
        };
    }, [loading, page, filteredCatalog]);

    if (visibleItems.length === 0) {
        return <EmptyStateMessage message={emptyMessage} />;
    }

    return (
        <>
            <Grid container spacing={2}>
                {visibleItems.map((item) => (
                    <Grid style={{ marginBottom: "2px" }} key={item.id} item xs={12} sm={6} lg={3}>
                        <ProductCard
                            onClickHandler={() =>
                                item.combo ? comboSelectedHandler(item) : productSelectedHandler(item)
                            }
                            rectangleColor={
                                !item.categoryColor ? (item.combo ? comboColor : productColor) : item.categoryColor
                            }
                            discount={item.discountAmount}
                            label={item.combo ? "Combo" : ""}
                            title={item.name}
                            price={amountToFixed(item.price, 2) || item.price}
                        />
                    </Grid>
                ))}
            </Grid>
            <div
                ref={loader}
                style={{
                    padding: "1rem",
                    textAlign: "center",
                }}
            >
                {loading ? "Cargando más..." : ""}
            </div>
        </>
    );
};

CatalogGrid.propTypes = {
    catalog: PropTypes.array,
    filterProductInputValue: PropTypes.string,
    isCombosSelected: PropTypes.bool,
    comboSelectedHandler: PropTypes.func,
    productSelectedHandler: PropTypes.func,
    comboColor: PropTypes.string,
    productColor: PropTypes.string,
    categoriesSelected: PropTypes.object,
    selectedLetter: PropTypes.string,
};

export default CatalogGrid;
